import React, { useState, useEffect, useCallback } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
} from "shards-react";
import { connect } from "react-redux";
import Loading from "../../Loading";
import { useRequestHook } from "../../../utils/hooks/hooks";
import Moment from "react-moment";
import AlertMessage from "../../AlertMessage";
import ConfirmModal from "../../ConfirmModal";
import UserFormModal from "./UserFormModal";
import { updateUserData } from "utils/redux/actions";

const UserSettings = ({ dispatch }) => {
  const [userList, setUserList] = useState(); //Define the default value for the documents to be rendered.
  const [toggleModal, setToggleModal] = useState();
  const [confirmDeleteUser, setConfirmDeleteUser] = useState();
  const { handleRequest } = useRequestHook(); //Define method to fetch data.

  /**
   * Handle modal open event.
   */
  const handleOpenModal = (userData) => {
    handleRequest(
      "post",
      "/settings/getRolesFromUserAndMandant",
      { userId: userData._id },
      (response) => {
        setToggleModal({
          userData: userData,
          userRoles: response.userRoles,
          mandantRoles: response.mandantRoles,
        });
      }
    );
  };
  /**
   * Handle add user button event.
   */
  const handleAddUser = () => {
    handleRequest("post", "/settings/getRolesFromMandant", {}, (response) => {
      setToggleModal({
        mandantRoles: response.mandantRoles,
      });
    });
  };
  /**
   * Handle delete user.
   */
  const handleDeleteUser = (userId) => {
    handleRequest(
      "post",
      "/settings/deleteUser",
      { userId: userId },
      (response) => {
        if (response === "ok") {
          setUserList((oldUserList) =>
            oldUserList.filter((item) => item.id !== userId)
          );
          setConfirmDeleteUser(false);
        }
      }
    );
  };

  const saveInRedux = useCallback(
    (userData) => dispatch(updateUserData(userData)),
    [dispatch]
  );

  useEffect(() => {
    if (userList === undefined) {
      handleRequest("post", "/settings/getUserByMandant", {}, (response) => {
        setUserList(response);
      });
    }
  }, [handleRequest, userList]);

  return (
    <>
      {userList === undefined ? (
        <Loading style={{ height: "50vh" }} />
      ) : (
        <>
          <Card small>
            <CardHeader className="border-bottom">
              <span className="mr-5 align-middle">Benutzer</span>
              <i
                className="fas fa-plus-circle text-success pointer align-middle"
                style={{ fontSize: "x-large" }}
                onClick={() => {
                  setToggleModal("loading");
                  handleAddUser();
                }}
              />
            </CardHeader>
            <CardBody className="p-0">
              <Container fluid className="p-0 pb-2">
                <Row
                  noGutters
                  className="py-2 px-3 bg-light border-bottom text-dark font-weight-bold"
                >
                  <Col xs="1">#</Col>
                  <Col xs="2">Name</Col>
                  <Col xs="3">E-Mail</Col>
                  <Col xs="2">Upload Name</Col>
                  <Col xs="1">Letzter Login</Col>
                  <Col xs="1" className="text-center">
                    Rollen
                  </Col>
                  <Col xs="2">Aktionen</Col>
                </Row>
                {userList.length === 0 && (
                  <AlertMessage
                    alertMessage={
                      "Es sind keine weiteren Benutzer registriert."
                    }
                  />
                )}
                {userList.length > 0 && (
                  <Container fluid className="p-0">
                    {userList.map((user, index) => (
                      <Row
                        key={index}
                        noGutters
                        className={`px-3 py-1 align-items-center ${
                          index % 2 ? "bg-light" : ""
                        }`}
                      >
                        <Col xs="1">{index + 1}</Col>
                        <Col xs="2">{user.full_name}</Col>
                        <Col xs="3">{user.mail}</Col>
                        <Col xs="2">{user.upload_name}</Col>
                        <Col xs="1">
                          <Moment format="DD.MM.YYYY" withTitle>
                            {user.last_login_date}
                          </Moment>
                        </Col>
                        <Col xs="1" className="text-center">
                          {user.rolesLength ? user.rolesLength : user.roles}
                        </Col>
                        <Col xs="2" className="d-flex">
                          <Button
                            pill
                            theme="warning"
                            onClick={() => {
                              setToggleModal("loading");
                              handleOpenModal(user);
                            }}
                          >
                            <i className="far fa-edit" />
                          </Button>
                          <Button
                            pill
                            theme="danger"
                            className="mx-auto"
                            onClick={() => setConfirmDeleteUser(user.id)}
                          >
                            <i className="far fa-trash-alt" />
                          </Button>
                        </Col>
                      </Row>
                    ))}
                  </Container>
                )}
              </Container>
            </CardBody>
          </Card>
          {confirmDeleteUser && (
            <ConfirmModal
              message={"Möchten Sie den ausgewählten Benutzer löschen?"}
              confirmFunction={() => handleDeleteUser(confirmDeleteUser)}
              closeModal={() => setConfirmDeleteUser(false)}
            />
          )}
          {toggleModal && (
            <UserFormModal
              modalData={toggleModal}
              setModalData={setToggleModal}
              saveInRedux={saveInRedux}
              setUserList={setUserList}
            />
          )}
        </>
      )}
    </>
  );
};
const mapStateToProps = ({ userData: { id, mandant } }) => ({ id, mandant });

export default connect(mapStateToProps)(UserSettings); //Export component and connect it with redux.
